export default {
  'REPORT' (state) {
    return state.report
  },
  'REPORTS' (state) {
    return state.reports
  }
}
